import React, {useMemo} from 'react';
import {useParams} from 'react-router';
import {Route, Switch} from 'react-router-dom';
import tinycolor2 from 'tinycolor2';
import {useEvent} from '../../data/hooks/eventHooks';

const StyleVariables = props => {
    const {eventId} = useParams(),
        event = useEvent(eventId),
        variables = useMemo(() => {
            const primaryColor = event?.settings.primary_color ?? '#33a0a5',
                secondaryColor = event?.settings.secondary_color ?? '#138e9b';

            return [
                ':root {',
                `--primary_color: ${primaryColor};`,
                `--primary_color_lighten_5: ${tinycolor2(primaryColor).lighten(5).toString()};`,
                `--primary_color_lighten_10: ${tinycolor2(primaryColor).lighten(10).toString()};`,
                `--primary_color_lighten_20: ${tinycolor2(primaryColor).lighten(20).toString()};`,
                `--primary_color_lighten_40: ${tinycolor2(primaryColor).lighten(40).toString()};`,
                `--primary_color_lighten_50: ${tinycolor2(primaryColor).lighten(50).toString()};`,
                `--primary_color_darken_05: ${tinycolor2(primaryColor).darken(5).toString()};`,
                `--primary_color_darken_10: ${tinycolor2(primaryColor).darken(10).toString()};`,
                `--secondary_color: ${secondaryColor};`,
                `--secondary_color_lighten_10: ${tinycolor2(secondaryColor).lighten(10).toString()};`,
                `--secondary_color_lighten_20: ${tinycolor2(secondaryColor).lighten(20).toString()};`,
                `--secondary_color_lighten_50: ${tinycolor2(secondaryColor).lighten(50).toString()};`,
                '}',
            ];
        }, [event?.settings]);

    return <style>{variables.join('\n')}</style>;
};

export default props => (
    <Switch>
        <Route path="/events/:eventId" component={StyleVariables} />
        <StyleVariables />
    </Switch>
);
